import { CanActivateFn } from '@angular/router';
import { Location } from '@angular/common';
import { inject } from '@angular/core';

import { AuthenticationService } from '~/core/services/authentication.service';
import { NavigationStateService } from '~/core/services/navigation-state.service';

export const openRegisterGuard: CanActivateFn = (route, state) => {
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const navState: NavigationStateService = inject(NavigationStateService);
  const location: Location = inject(Location);

  // Check for 'openRegister' in query params and fragment
  let hasToOpenRegister = route.queryParamMap.get('openRegister');
  if (!hasToOpenRegister && route.fragment) {
    const fragmentQueryMatch = route.fragment.match(/[?&]openRegister=([^&]*)/);
    if (fragmentQueryMatch) {
      hasToOpenRegister = fragmentQueryMatch[1];
    }
  }

  if (Boolean(hasToOpenRegister) && !authenticationService.isLoggedIn()) {
    const cleanUrl = state.url?.replace('?openRegister=true', '')?.replace('&openRegister=true', '');
    navState.setLastUrl(cleanUrl);
    authenticationService.openRegisterScreen(location, true, route.queryParams);
  }
  return true;
};
